import getHealthAlive from './getHealthAlive';
import getClientGeneral from './clients/getClientGeneral';
import patchClientGeneralBySid from './clients/patchClientGeneralBySid';
import getClientContentEngine from './clients/getClientContentEngine';
import getClientProvider from './clients/getClientProvider';
import deleteRiskCaches from './risks/deleteRiskCaches';
import patchClientContentEngineBySid from './clients/patchClientContentEngineBySid';
import getClientStudentManagement from './clients/getClientStudentManagement';
import getClientExcursionManagement from './clients/getClientExcursionManagement';
import getClientExcursionManagementVendorsList from './clients/getClientExcursionManagementVendorsList';

export default (axios, baseUrl) => {
  return {
    getHealthAlive: () => getHealthAlive(axios, baseUrl),
    getClientGeneral: getClientGeneral(axios, baseUrl),
    patchClientGeneralBySid: patchClientGeneralBySid(axios, baseUrl),
    getClientContentEngine: getClientContentEngine(axios, baseUrl),
    deleteRiskCaches: deleteRiskCaches(axios, baseUrl),
    patchClientContentEngineBySid: patchClientContentEngineBySid(axios, baseUrl),
    getClientProvider: getClientProvider(axios, baseUrl),
    getClientStudentManagement: getClientStudentManagement(axios, baseUrl),
    getClientExcursionManagement: getClientExcursionManagement(axios, baseUrl),
    getClientExcursionManagementVendorsList: getClientExcursionManagementVendorsList(axios, baseUrl)
  };
};
